import axiosInstance from "./AxiosInstance";

const ApiService = {
  

// Authentication APIssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss

  login: async (formData) => {
    try {
      const response = await axiosInstance.post("/login", formData);
      return response;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  },

  forgotPassword: async (formData) => {
    try {
      const response = await axiosInstance.post("/forgot-password", formData);
      return response.data;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  },
  changePassword: async (formData, token) => {
    try {
      const response = await axiosInstance.post(
        "/change-password",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass token in Authorization header
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  },


  ///////////////////////////////// clients apis /////////////////////////////////////
  
  handleGetAllPlans: async (formData) => {
      try {
        const response = await axiosInstance.post("/get-all-plans", formData);
        return response.data;
      } catch (error) {
        console.error("Error logging in:", error);
        throw error;
      }
    },
    handleGetAllBenefits: async (formData) => {
      try {
        const response = await axiosInstance.post("/get-all-benefits", formData);
        return response.data;
      } catch (error) {
        console.error("Error logging in:", error);
        throw error;
      }
    },
    handleQuoteSubmission: async (formData) => {
      try {
        const response = await axiosInstance.post("/send-email", formData);
        return response.data;
      } catch (error) {
        console.error("Error logging in:", error);
        throw error;
      }
    },
    /////////////////////admin //////////////////////////////////////

    getModules: async () => {
      try {
        const response = await axiosInstance.get(`/admin/plans`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    getModulesById: async (id) => {
      try {
        const response = await axiosInstance.get(`/admin/plans/${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    getAdminMetrcis: async () => {
      try {
        const response = await axiosInstance.get(`/admin/admin-metrcis`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    createModule: async (data) => {
      try {
        const response = await axiosInstance.post('/admin/plans', data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    updateModule: async (id, data) => {
      try {
        const response = await axiosInstance.put(`/admin/plans/${id}`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    deleteModule: async (id) => {
      try {
        const response = await axiosInstance.delete(`/admin/plans/${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    getPremiumFields: async () => {
      try {
        const response = await axiosInstance.get('/admin/premium-fields');
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    getPremiums: async (data) => {
      try {
        const response = await axiosInstance.post('/admin/premiums', data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    createPremium: async (data) => {
      try {
        const response = await axiosInstance.post('/admin/create-premiums', data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    updatePremium: async (id, data) => {
      try {
        const response = await axiosInstance.put(`/admin/premiums/${id}`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    deletePremium: async (id) => {
      try {
        const response = await axiosInstance.delete(`/premiums/${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    getQuotesManagement: async () => {
      try {
        const response = await axiosInstance.get('/admin/quotes');
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    getQuoteByIdManagement: async (id) => {
      try {
        const response = await axiosInstance.get(`/admin/quotes/${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    deleteQuoteByIdManagement: async (id) => {
      try {
        const response = await axiosInstance.delete(`/admin/quotes/${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  
    updateQuoteByIdManagement: async (id, data) => {
      try {
        const response = await axiosInstance.put(`admin/quotes/${id}`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

}




export default ApiService;
